export let FormBackgroundDesign = /*#__PURE__*/function (FormBackgroundDesign) {
  FormBackgroundDesign["Solid"] = "Solid";
  FormBackgroundDesign["Transparent"] = "Transparent";
  return FormBackgroundDesign;
}({});